module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"company_details":"Company Details","company_description":"This informations will be used in your company invoice"},"ms":{"test":"Assalamualaikum"}}')
  delete Component.options._Ctor
}
